<template>
  <div class="page-not-found">
    <lottie :options="lottieOptions" :height="400" />
    <div class="page-not-found__msg">Page not found</div>
    <div class="page-not-found__action">
      Go back <router-link to="/">home</router-link>
    </div>
  </div>
</template>

<script>
import Lottie from "vue-lottie";
import * as animationData from "../assets/404_lottie.json";

export default {
  name: "PageNotFound",
  components: {
    lottie: Lottie
  },
  data() {
    return {
      lottieOptions: { animationData: animationData.default }
    };
  },
  methods: {}
};
</script>

<style lang="scss">
.page-not-found__msg {
  font-size: 40px;
}
.page-not-found__action {
  margin-top: 30px;
}
</style>
